import React, { PureComponent } from 'react'
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  MenuItem,
  Button,
} from '@material-ui/core'
import {
  getSpringBigList,
  updateSpringBigInfo,
  createSpringBigInfo,
  syncSpringBigMembers,
  getLastsyncSpringBigMembers,
} from '../../../actions/integration'
import { getShopList } from '../../../actions/shop'
import ContainerWithTitleWrapper from '../../HOC/ContainerWithTitle'
import { connect } from 'react-redux'
import {
  TableCellWithSwitch,
  TableCellWithTextField,
  TableCellWithSelect,
} from '../../../components/common/PureItems'
import EditableHOCWrapper from '../../HOC/EditableHOC'
import { openErrorMessage, openSuccessMessage } from '../../../actions/message'
import { hasAccess } from '../../../utils/api'
import { Appcues } from '../../../utils/constants'
import EditActionComponent from '../../../components/common/EditActionComponent'
import SpringbigModalSyncMembers from '../../../components/Springbig/SpringbigModalSyncMembers'

class SpringBig extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      springBigInfo: {},
      modalSyncMembers: false,
      shopId: '',
      lastSyncInProgress: false,
    }
  }

  componentDidMount() {
    this.fetchSpringBigList()
    this.props.dispatch(getShopList())
    this.props.dispatch(getLastsyncSpringBigMembers()).then((syncLog) => {
      if (syncLog && syncLog.status !== 'COMPLETE' && syncLog.status !== 'ERROR') {
        this.setState({
          lastSyncInProgress: true,
        })
      }
    })
  }

  fetchSpringBigList = () => {
    const data = {}
    this.props.dispatch(getSpringBigList()).then((springBigList) => {
      springBigList &&
        springBigList.length &&
        springBigList.forEach((item) => {
          data[item.shopId] = { ...(data[item.shopId] || {}), ...item }
        })
      this.setState({
        springBigInfo: data,
      })
    })
  }

  setChange = (shopId, key, isCheckBox) => (event) => {
    const { springBigInfo = {} } = this.state
    let updatedSpringBigInfo = { ...springBigInfo }
    updatedSpringBigInfo = {
      ...updatedSpringBigInfo,
      [shopId]: {
        ...updatedSpringBigInfo[shopId],
        [key]: isCheckBox ? event.target.checked : event.target.value,
      },
    }
    // console.log(key, updatedSpringBigInfo, "updatedSpringBigInfo")
    this.setState({
      springBigInfo: updatedSpringBigInfo,
    })
  }

  onSave = (shopId) => (data, afterSave) => {
    const { springBigInfo } = this.state
    if (!(springBigInfo[shopId] && springBigInfo[shopId].authToken)) {
      this.props.dispatch(openErrorMessage('Please specify auth token'))
      return
    }

    if (springBigInfo[shopId] && springBigInfo[shopId].id) {
      this.props.dispatch(updateSpringBigInfo(springBigInfo[shopId])).then((res) => {
        this.fetchSpringBigList()
        afterSave && afterSave()
      })
    } else if (springBigInfo[shopId]) {
      this.props.dispatch(createSpringBigInfo({ ...springBigInfo[shopId], shopId })).then((res) => {
        this.fetchSpringBigList()
        afterSave && afterSave()
      })
    }
  }

  onSync = (shopId) => () => {
    this.setState({
      modalSyncMembers: true,
      shopId: shopId,
    })
  }

  startSync = (source, fields) => {
    const { shopId } = this.state
    this.props.dispatch(syncSpringBigMembers({ shopId, source, fields })).then((res) => {
      this.props.dispatch(openErrorMessage('Sync has been started successfully.'))
      this.setState({
        lastSyncInProgress: true,
      })
    })
    this.handleCloseModalSync()
  }

  handleCloseModalSync = () => {
    this.setState({
      modalSyncMembers: false,
    })
  }

  resetState = (shopId) => () => {
    const { springBigInfo } = this.state
    const { springBigList = [] } = this.props.integrationReducer
    const oldState = springBigList.find((elem) => elem.shopId === shopId)
    this.setState({
      springBigInfo: {
        ...springBigInfo,
        [shopId]: {
          ...(oldState || {}),
        },
      },
    })
  }

  render() {
    const { shopsList = {} } = this.props.shopReducer
    const springBigShops =
      shopsList &&
      shopsList.values &&
      shopsList.values.filter(
        (shop) => shop.appTarget !== 'Grow' && shop.appTarget !== 'Distribution',
      )
    const { springBigInfo = {}, modalSyncMembers = false, lastSyncInProgress = false } = this.state

    return (
      <div>
        <Grid container>
          <Grid className="unversalScroll" item xs={12} sm={12} md={12} lg={12}>
            <Paper>
              <div className="table-scroll">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Shop</TableCell>
                      <TableCell>Auth Token</TableCell>
                      <TableCell>Environment</TableCell>
                      <TableCell>Status</TableCell>
                      {hasAccess() ? <TableCell></TableCell> : null}
                      {/*{hasAccess() ? <TableCell className="text-align-center">Actions</TableCell> : null}*/}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {springBigShops &&
                      springBigShops.length &&
                      springBigShops.map((shop, index) => {
                        //const checked = springBigInfo[shop.id] && springBigInfo[shop.id].active || false;
                        return (
                          <SpringBigItemEditable
                            key={index}
                            shop={shop}
                            springBigInfo={springBigInfo}
                            onChange={this.setChange}
                            onSave={this.onSave(shop.id)}
                            resetState={this.resetState(shop.id)}
                            dataToEdit={springBigInfo[shop.id] || {}}
                            onSaveSync={this.onSync(shop.id)}
                            lastSyncInProgress={lastSyncInProgress}
                          />
                        )
                      })}
                  </TableBody>
                </Table>
              </div>
            </Paper>
          </Grid>
          {modalSyncMembers && (
            <SpringbigModalSyncMembers
              open={modalSyncMembers}
              startSync={this.startSync}
              close={this.handleCloseModalSync}
            />
          )}
        </Grid>
      </div>
    )
  }
}

const SpringBigWithTitle = ContainerWithTitleWrapper(SpringBig, 'springbig')
const SpringBigConnected = connect(({ shopReducer, integrationReducer, dispatch }) => ({
  shopReducer,
  integrationReducer,
  dispatch,
}))(SpringBigWithTitle)

class SpringBigItem extends PureComponent {
  onSave = () => {
    Appcues.track('Shop Info saved for SpringBig')
    this.props.onSave(this.props.disableEdit)
  }

  onCancel = () => {
    this.props.resetState()
    this.props.onCancel()
  }

  onSaveSync = () => {
    this.props.onSaveSync()
  }

  render() {
    const {
      shop = {},
      springBigInfo = {},
      editMode = false,
      syncMode = false,
      lastSyncInProgress = false,
    } = this.props

    //const checked = springBigInfo[shop.id] && springBigInfo[shop.id].active || false;

    const data = (springBigInfo[shop.id] && springBigInfo[shop.id]) || {}
    // console.log("props s ", this.props)
    return (
      <TableRow>
        <TableCell>{shop.name}</TableCell>
        <TableCellWithTextField
          valueToRender={data.authToken || ''}
          value={data.authToken}
          editMode={editMode}
          onChange={this.props.onChange(shop.id, 'authToken', false)}
        />
        <TableCellWithSelect
          valueToRender={data.env ? (data.env === 'STAGE' ? 'Testing' : 'Production') : ''}
          value={data.env}
          editMode={editMode}
          onChange={this.props.onChange(shop.id, 'env', false)}
        >
          <MenuItem key="Development" value="STAGE">
            Testing
          </MenuItem>
          <MenuItem key="Production" value="PROD">
            Production
          </MenuItem>
        </TableCellWithSelect>
        <TableCellWithSwitch
          valueToRender={data.active ? 'Enabled' : 'Disabled'}
          checked={data.active}
          editMode={editMode}
          onChange={this.props.onChange(shop.id, 'active', true)}
        />
        {hasAccess() ? (
          <TableCell className="cell-wrap-word">
            <EditActionComponent
              classButton={'btn-border-radius-primary-inverse'}
              classButtonDelete={'btn-border-radius-danger'}
              onSave={this.onSave}
              onCancel={this.onCancel}
              onEdit={this.props.enableEdit}
              editMode={editMode}
            />
          </TableCell>
        ) : null}
      </TableRow>
    )
  }
}

const SpringBigItemEditable = EditableHOCWrapper(SpringBigItem)

export default SpringBigConnected



// WEBPACK FOOTER //
// ./src/containers/Settings/Integration/SpringBig.js